
var verifyUtils = require("./verifyUtils");
var metaTypeUtils = require("./metaTypeUtils");
var metaService = require("../services/metaService");
module.exports = {
    open:function(options){
        var index;
        if(options.form){
            this.formRender(options.form);
            options.cancel = function(){
                var formId = options.form.formId?options.form.formId:"userForm";
                //document.getElementById(formId).reset();
                $("#"+formId).find("input,select,textarea").val(undefined);
            }
        }
        layui.use(['layer'], function(){
            var layer = layui.layer;
            index = layer.open(options);
        })
        return index;
    },
    close:function(index){
        layui.use(['layer'], function(){
            var layer = layui.layer;
            layer.close(index);
        })
    },
    msg:function(message){
        layui.use(['layer'], function(){
            var layer = layui.layer;
            layer.msg(message);
        })
    },
    alert:function(message,option){
        layui.use(['layer'], function(){
            var layer = layui.layer;
            layer.alert(message,option);
        })
    },
    confirm:function(message,callback){
        layui.use(['layer'], function(){
            var layer = layui.layer;
            layer.confirm(message,{

            },function(index,layero){
                callback(index,layero);
                layer.close(index);
            });
        })
    },
    closeAll:function(){
        layui.use(['layer'], function(){
            var layer = layui.layer;
            layer.closeAll(index);
        })
    },
    
    formRender:function(options){
        layui.use(["form"], function(){
            var form = layui.form;
            options.formId = options.formId?options.formId:"userForm";
            options.submitId = options.submitId?options.submitId:"userInfo";
            form.on("submit("+options.submitId+")", function(data){
                options.callback(data.field)
                return false;
            });
            if(options.data){
                console.log(options);
                form.val(options.formId,JSON.parse(JSON.stringify(options.data)));
            }
            if(options.attrs&&options.attrs.length>0){
                form.verify(metaTypeUtils.verifyUtils(options.attrs))
            }else{
                form.verify(verifyUtils)
            }
            form.render();
        })
    },
    table:function(options){
        layui.use(["layer"], function(){
            var table = layui.table;
            options.height = options.height?options.height:600;
            options.method = options.method?options.method:"get";
            options.limits = [10,20,50,100];
            options.request = {
                pageName: 'pageNumber', 
                limitName: "pageSize"
            };
            if(options.method === "post"){
                options.request.limitName = "size";
                options.contentType = 'application/json';
            }
            options.parseData = function(res){
                console.log(res)
                var total = 0;
                var page = {
                    pageNumber:res.data.pageNumber,
                    pageSize:res.data.pageSize
                }
                if(res.data.result.length >= page.pageSize){
                    total = page.pageSize*page.pageNumber+1;
                }else{
                    total = page.pageSize*(page.pageNumber-1)+res.data.result.length;
                }
                console.log(total)
                return {
                    "code": 0,
                    "msg": "",
                    "count": total,
                    "data": res.data.result
                  } 
            };
            table.render(options);
            if(options.event){
                table.on(options.event.id,options.event.callback);
            }
        })
    },
}


//////////////////
// WEBPACK FOOTER
// ./src/utiles/layUtils.js
// module id = 4
// module chunks = 0